import { TopBarTitle } from '@ksyos/design-system';
import { Outlet, useParams } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { AuthorizationErrorCode, ManagerAuthorization } from '@common/enums';
import { getLanguage } from '@common/translate/translate';
import { assertHasAuthorization, hasOneAuthorization, useAbortableFetch } from '@frontend/utils';
import { PageTemplate } from '../../templates/PageTemplate';
import { ProfileNavigation } from '../profile/ProfileNavigation';

export function PractitionerProfile() {
    const abortableFetch = useAbortableFetch();
    const translate = getLanguage();
    const isManager = useSelector((state: IReduxState) => state.authentication.isManager);
    const authenticatedPractitionerId = useSelector((state: IReduxState) => state.authentication.id);
    const { id: practitionerId } = useParams() as { id: string };
    const [practitionerIsKsyosManager, setPractitionerIsKsyosManager] = useState<boolean>();

    useEffect(() => {
        getPractitionerIsKsyos();
    }, []);

    useEffect(() => {
        if (practitionerIsKsyosManager !== undefined && practitionerId !== authenticatedPractitionerId) {
            if (isManager && practitionerIsKsyosManager) {
                assertHasAuthorization([ManagerAuthorization.adminsRead, ManagerAuthorization.practitionerRead]);
            } else if (isManager) {
                assertHasAuthorization(ManagerAuthorization.practitionerRead);
            } else {
                throw new Error(AuthorizationErrorCode.CANNOT_VIEW_OTHER_PRACTITIONERS_PROFILE);
            }
        }
    }, [practitionerIsKsyosManager]);

    return (
        <PageTemplate
            sideBarNavigation={renderNavigation()}
            topBarNavigation={renderNavigation()}
            topBarProfile={<TopBarTitle>{translate.common.profile}</TopBarTitle>}
            width="small"
        >
            <Outlet />
        </PageTemplate>
    );

    async function getPractitionerIsKsyos() {
        if (isManager && practitionerId !== authenticatedPractitionerId) {
            const result = await abortableFetch.fetchJson(`/api/employments/${practitionerId}/isKsyosManager`, 'GET');
            setPractitionerIsKsyosManager(result.json.isKsyosManager);
        }
    }

    function renderNavigation() {
        return (
            <ProfileNavigation
                hasAccessToOldProfile={hasOneAuthorization(ManagerAuthorization.employmentsOld)}
                practitionerId={practitionerId}
            />
        );
    }
}
